export const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || 'AW-18204824062';

export const CONVERSION_LABELS = {
  purchase: process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL || '',
  signup: process.env.REACT_APP_GOOGLE_ADS_SIGNUP_LABEL || '',
  enterpriseLead: process.env.REACT_APP_GOOGLE_ADS_ENTERPRISE_LEAD_LABEL || '',
  reportLead: process.env.REACT_APP_GOOGLE_ADS_REPORT_LEAD_LABEL || '',
};

export const CONSENT_STORAGE_KEY = 'marketscan_google_consent_v1';
export const CLICK_ID_STORAGE_KEY = 'marketscan_google_click_ids_v1';
const SENT_CONVERSIONS_KEY = 'marketscan_sent_google_conversions_v1';
const GOOGLE_CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];
let pendingConversions = [];

const storage = (kind) => {
  if (typeof window === 'undefined') return null;
  try { return window[kind]; } catch (_) { return null; }
};

export function getStoredConsent() {
  try {
    const raw = storage('localStorage')?.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.advertising !== 'boolean') return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function updateGoogleConsent(advertising) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  const state = advertising ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    ad_storage: state,
    analytics_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  });
}

export function saveConsent(advertising) {
  const choice = { advertising: Boolean(advertising), updatedAt: new Date().toISOString() };
  try { storage('localStorage')?.setItem(CONSENT_STORAGE_KEY, JSON.stringify(choice)); } catch (_) {}
  updateGoogleConsent(choice.advertising);
  return choice;
}

export function hasAdvertisingConsent() {
  return getStoredConsent()?.advertising === true;
}

export function captureGoogleClickIds(search = typeof window !== 'undefined' ? window.location.search : '') {
  const params = new URLSearchParams(search || '');
  const captured = {};
  GOOGLE_CLICK_IDS.forEach((key) => {
    const value = params.get(key);
    if (value && /^[A-Za-z0-9._~-]{1,256}$/.test(value)) captured[key] = value;
  });
  if (!Object.keys(captured).length) return getStoredGoogleClickIds();
  const record = { ...captured, capturedAt: new Date().toISOString() };
  try { storage('sessionStorage')?.setItem(CLICK_ID_STORAGE_KEY, JSON.stringify(record)); } catch (_) {}
  return record;
}

export function getStoredGoogleClickIds() {
  try { return JSON.parse(storage('sessionStorage')?.getItem(CLICK_ID_STORAGE_KEY) || '{}'); } catch (_) { return {}; }
}

export function withStoredClickIds(path) {
  if (typeof window === 'undefined') return path;
  const url = new URL(path, window.location.origin);
  const ids = getStoredGoogleClickIds();
  GOOGLE_CLICK_IDS.forEach((key) => { if (ids[key] && !url.searchParams.has(key)) url.searchParams.set(key, ids[key]); });
  return `${url.pathname}${url.search}${url.hash}`;
}

function wasSent(key) {
  try { return JSON.parse(storage('sessionStorage')?.getItem(SENT_CONVERSIONS_KEY) || '{}')[key] === true; } catch (_) { return false; }
}

function markSent(key) {
  try {
    const current = JSON.parse(storage('sessionStorage')?.getItem(SENT_CONVERSIONS_KEY) || '{}');
    current[key] = true;
    storage('sessionStorage')?.setItem(SENT_CONVERSIONS_KEY, JSON.stringify(current));
  } catch (_) {}
}

export function sendGoogleAdsConversion(type, options = {}) {
  const label = CONVERSION_LABELS[type];
  if (!label || typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  if (!hasAdvertisingConsent()) {
    if (getStoredConsent() === null) pendingConversions.push({ type, options });
    return false;
  }
  const dedupeKey = options.dedupeKey || `${type}:${options.transactionId || 'once'}`;
  if (wasSent(dedupeKey)) return false;

  if (options.email) window.gtag('set', 'user_data', { email: String(options.email).trim().toLowerCase() });
  const payload = { send_to: `${GOOGLE_ADS_ID}/${label}` };
  if (Number.isFinite(options.value)) payload.value = options.value;
  if (options.currency && /^[A-Z]{3}$/.test(options.currency)) payload.currency = options.currency;
  if (options.transactionId) payload.transaction_id = String(options.transactionId);
  window.gtag('event', 'conversion', payload);
  markSent(dedupeKey);
  return true;
}

export function trackGoogleAdsDiagnostic(name, params = {}) {
  if (!hasAdvertisingConsent() || typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  window.gtag('event', name, params);
  return true;
}
